import { render, staticRenderFns } from "./Exception05.vue?vue&type=template&id=3a4075e3&scoped=true"
import script from "./Exception05.vue?vue&type=script&lang=js"
export * from "./Exception05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4075e3",
  null
  
)

export default component.exports